export type EditRheologyPageParams = Readonly<Record<'entityId' | 'rheologyId', string | undefined>>;

export const ROUTE_PARAM_IDENTIFIER = ':entityId';
export const ROUTE_RHEOLOGY_DATA_IDENTIFIER = ':rheologyId';
export const ROUTE_PATH = `/admin/projects/${ROUTE_PARAM_IDENTIFIER}/rheology/edit/${ROUTE_RHEOLOGY_DATA_IDENTIFIER}`;
export const TITLE = 'Edit Rheology';
